<div class="d-flex align-items-center gap-3 flex-shrink-0">
    <!--button type="button" class="btn btn-light d-none d-lg-block" aria-label="Notifications">
        <i class="fa-regular fa-bell"></i>
    </button-->

    <div ngbDropdown placement="bottom-end" autoClose="outside">
        <button type="button" class="btn btn-light d-flex align-items-center gap-2 border" ngbDropdownToggle>
            <span class="avatar-sm" aria-hidden="true">
                @if (currentUser?.avatarUrl){
                <img [src]="currentUser?.avatarUrl" />
                } @else {
                <span class="avatar-initials" aria-hidden="true">
                    {{
                    currentUser?.initials
                    }}
                </span>
                }
            </span>
            <span class="d-none d-xl-inline">{{currentUser?.fullName }}</span>
        </button>

        <div ngbDropdownMenu>

            <div class="px-3 py-2">
                <div class="d-flex align-items-center">
                    <div class="d-flex flex-column gap-2">
                        <span class="fw-semibold">{{ currentUser?.profileName }}</span>
                        <span class="small text-muted">{{ currentUser?.email }}</span>
                    </div>
                </div>
            </div>
            <div class="dropdown-divider"></div>

            <button class="d-lg-none" ngbDropdownItem type="button">
                <i class="fa-regular fa-bell"></i>
                {{ 'components.topbar.notifications.label' | translate }}
            </button>

            <button ngbDropdownItem type="button" class="d-flex align-items-center justify-content-between gap-2"
                (click)="$event.stopPropagation(); toggleLanguageMenu()">
                <span class="d-flex align-items-center gap-2">
                    <i class="fa-solid fa-language"></i>
                    <span>{{ 'components.topbar.language.label' | translate }}</span>
                </span>
                <i class="fa-solid small" [class.fa-chevron-down]="!languageMenuOpen()"
                    [class.fa-chevron-up]="languageMenuOpen()" aria-hidden="true">
                </i>
            </button>

            @if (languageMenuOpen()) {
            <div class="language-submenu">
                @for (language of supportedLanguages(); track language.code) {
                <button type="button"
                    class="dropdown-item language-submenu-item d-flex align-items-center justify-content-between gap-2"
                    [class.active]="isCurrentLang(language.code)"
                    (click)="$event.stopPropagation(); changeLang(language.code)">
                    <span>{{ language.label }}</span>
                    @if (isCurrentLang(language.code)) {
                    <i class="fa-solid fa-check" aria-hidden="true"></i>
                    }
                </button>
                }
            </div>
            }

            <button ngbDropdownItem type="button" (click)="toggleTheme()">
                <i class="fa-solid me-1" [class.fa-sun]="theme()!=='light'" [class.fa-moon]="theme()==='light'"></i>
                <span>{{ 'components.topbar.themes.'+(theme()==='light' ? 'dark' : 'light') | translate }}</span>
            </button>
            <div class="dropdown-divider"></div>

            <!-- Account -->


            <button ngbDropdownItem type="button" (click)="openProfileModal()">
                <i class="fa-regular fa-user"></i>
                {{ 'components.topbar.profile.label' | translate }}
            </button>

            <div class="dropdown-divider"></div>

            <button ngbDropdownItem type="button" class="gap-2" [disabled]="loggingOut()" (click)="logout()">
                <i class="fa-solid fa-right-from-bracket"></i>
                {{ 'components.topbar.sign-out.label' | translate }}
            </button>
        </div>
    </div>
</div>

<app-user-profile-modal [loading]="profileLoading()" [open]="profileOpen()" [profile]="profileData()"
    (closed)="closeProfileModal()" />